import React from 'react';
import { Button } from '@/Components/shadcn/button';
import { TypographyH3, TypographyP } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';

function CandidateInputFormHeader(): React.JSX.Element {
    const { setPreviewInvitationEmailDialogOpen } = useInviteCandidateContext();

    return (
        <div className="flex flex-row flex-wrap items-center gap-2.5">
            <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline">
                <TypographyH3>{UIStrings.InvitationEmail}</TypographyH3>
                <TypographyP className="text-foreground font-normal md:inline">
                    {` - ${UIStrings.UsesTalentMeshBestPractices} `}
                </TypographyP>
            </div>
            <Button
                type="button"
                variant="outline"
                size="xs"
                className="text-secondary-foreground border-foreground shrink-0"
                onClick={() => setPreviewInvitationEmailDialogOpen(true)}
            >
                {UIStrings.Preview}
            </Button>
        </div>
    );
}

export default CandidateInputFormHeader;
